import cloneDeep from 'lodash/cloneDeep';
import {
  CLEAR_HYP_STDERR,
  CLEAR_HYP_STDOUT,
  SET_JOB_INFO,
  SET_TEST_SUMMARY_PORT,
  UPDATE_HYP_STATUS,
  UPDATE_HYP_STDERR,
  UPDATE_HYP_STDOUT,
  UPDATE_HYP_STATUS_SSE,
  TEST_RUNNNIG_BIN_STOPPED,
  CLEAR_HYP_FOLDER_PATH,
} from '../actions/hyplogs';
import { getUserDB } from '@/utils/db';
import log from 'electron-log/renderer';

const initialState: any = {};

const jobStatus = [
  'initiated',
  'running',
  'completed',
  'error',
  'skipped',
  'failed',
  'aborted',
  'lambda_error',
  'timeout',
  'blocked',
];

const updateStatusSSE = (payload: any, state: any) => {
  const folderPath = payload?.selectedFolder;
  const jobId = payload?.jobId;
  const db = getUserDB(payload?.userId);

  // ignore the event if id is not matching
  if (state?.[folderPath]?.id !== payload?.id) {
    return cloneDeep(state);
  }

  if (
    payload?.isExit &&
    folderPath &&
    ['initiated', 'running'].includes(state?.[folderPath]?.status) &&
    jobStatus?.indexOf(payload?.status) >
      jobStatus?.indexOf(state?.[folderPath]?.status)
  ) {
    db?.jobRunsList
      ?.where('id')
      ?.equals(payload?.id || -1)
      ?.modify({
        status: payload?.status,
        message: payload?.message,
        updatedAt: new Date(),
      })
      .then(() => {
        log.info('Job exit status updated in DB:', payload);
      })
      .catch((error) => {
        log.error('Error in exit updating job status in DB:', error);
      });
    return {
      ...state,
      [folderPath]: {
        ...state[folderPath],
        status: payload?.status,
        message: payload?.message,
        isRunning: false,
      },
    };
  }

  if (state?.[folderPath]?.jobInfo?.jobID !== jobId || jobId == undefined) {
    return cloneDeep(state);
  }

  // below condition handle race-condition in sse-events and update status only if it is greater than the current status
  if (
    folderPath &&
    ['initiated', 'running'].includes(state?.[folderPath]?.status) &&
    jobStatus?.indexOf(payload?.status) >
      jobStatus?.indexOf(state?.[folderPath]?.status)
  ) {
    db?.jobRunsList
      ?.where('id')
      ?.equals(payload?.id || -1)
      ?.modify({
        status: payload?.status,
        message: payload?.message,
        jobId: payload?.jobId || '',
        updatedAt: new Date(),
      })
      .then(() => {
        log.info('Job status updated in DB:', payload?.status);
      })
      .catch((error) => {
        log.error('Error updating job status in DB:', error);
      });
    return {
      ...state,
      [folderPath]: {
        ...state[folderPath],
        status: payload?.status,
        message: payload?.message,
        isRunning: ['initiated', 'running'].includes(payload?.status) === true,
      },
    };
  }

  return state;
};

const handleDuplicateLogs = (action: any, selectedFolder: any, state: any) => {
  const logs = cloneDeep(state[selectedFolder]?.stdout || []);
  const len = logs.length;
  const stdout = action.payload?.stdout?.trim();

  if (state?.[selectedFolder]?.id !== action?.payload?.id) {
    return cloneDeep(state);
  }

  if (!stdout) {
    return cloneDeep(state);
  }

  if (
    len > 1 &&
    ((logs[len - 1]?.includes('Running Job') &&
      stdout?.includes('Running Job')) ||
      (logs[len - 1]?.includes('stages completed') &&
        stdout?.includes('stages completed')))
  ) {
    logs[len - 1] = stdout;
  } else {
    logs.push(stdout);
  }
  return {
    ...state,
    [selectedFolder]: {
      ...state[selectedFolder],
      stdout: logs,
    },
  };
};

export default function hyperexecuteBinaryLogs(
  state = initialState,
  action: any
) {
  const selectedFolder = action?.payload?.selectedFolder;
  switch (action.type) {
    case SET_JOB_INFO: {
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          jobInfo: action.payload?.jobInfo,
        },
      };
    }
    case UPDATE_HYP_STDOUT:
      return handleDuplicateLogs(action, selectedFolder, state);
    case UPDATE_HYP_STDERR:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          stderr: state[selectedFolder].stderr + action.payload?.stderr,
        },
      };
    case UPDATE_HYP_STATUS:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          status: action.payload?.status,
          message: action.payload?.message,
        },
      };
    case CLEAR_HYP_STDERR:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          stderr: '',
        },
      };
    case CLEAR_HYP_STDOUT:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          stdout: '',
        },
      };
    case SET_TEST_SUMMARY_PORT:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          testSummaryPort: action.payload?.testSummaryPort,
          id: action.payload?.id,
          logPath: action.payload?.logPath,
          processId: action.payload?.processId,
        },
      };
    case UPDATE_HYP_STATUS_SSE:
      return updateStatusSSE(action.payload, state);
    case TEST_RUNNNIG_BIN_STOPPED:
      return {
        ...state,
        [selectedFolder]: {
          ...state[selectedFolder],
          isRunning: action.payload?.isRunning,
        },
      };
    case CLEAR_HYP_FOLDER_PATH:
      return {
        ...state,
        [selectedFolder]: {},
      };
    default:
      return { ...state };
  }
}
